import { render } from "./DocExpiration.vue?vue&type=template&id=c77be0de"
import script from "./DocExpiration.vue?vue&type=script&lang=js"
export * from "./DocExpiration.vue?vue&type=script&lang=js"

import exportComponent from "D:\\Projects\\JCXS\\CAAMSNG\\frontend-caams\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__